// The "Frame 341" inline disclosure pattern (spec 2.3/2.4/4.2): bold label + 16x16 chevron-circle,
// apex down collapsed / up expanded. Used for Projected Interest's "View details"/"Hide details".
function Chevron({ up }) {
  const d = up ? 'M5 9L8 6L11 9' : 'M5 7L8 10L11 7'
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d={d} stroke="#4F5F4A" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default function DisclosureToggle({ collapsedLabel, expandedLabel, expanded, onToggle }) {
  return (
    <button
      type="button"
      tabIndex={-1}
      aria-expanded={expanded}
      onClick={onToggle}
      className="group inline-flex items-center gap-x-[6px] outline-none focus-visible:ring-2 focus-visible:ring-brand-green rounded-[4px]"
    >
      <span className="text-[14px] font-bold text-brand-secondary group-hover:text-brand-hover">{expanded ? expandedLabel : collapsedLabel}</span>
      <span className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EEF3EC] group-hover:bg-[#DDE9D8]">
        <Chevron up={expanded} />
      </span>
    </button>
  )
}
